import { Modal, Typography } from "@codat/orchard-ui";
import React from "react";

interface RefreshDataModalProps {
  onCancel: () => void;
  onRefreshData: () => void;
}

const RefreshDataModal: React.FC<RefreshDataModalProps> = ({
  onCancel,
  onRefreshData,
}) => (
  <Modal
    isPinned
    onClose={onCancel}
    size="small"
    data-testid="refresh-data-modal"
  >
    <>
      <Modal.Header title={"This company is up to date"} onClose={null} />
      <Modal.Body variant="light">
        <Modal.Section variant="fill">
          <Typography variant="body_md" as="p" noMargin>
            The data for this company was refreshed within the last 24 hours.
            You can still refresh the data if you need to.
          </Typography>
        </Modal.Section>
      </Modal.Body>
      <Modal.Footer
        variant="light"
        buttons={[
          {
            key: "refreshButton",
            label: "Refresh data",
            onClick: onRefreshData,
            "data-testid": "refresh-data-modal-refresh",
            variant: "secondary",
            color: "interface",
          },
          {
            key: "cancelButton",
            label: "Cancel",
            onClick: onCancel,
            "data-testid": "refresh-data-modal-cancel",
            variant: "secondary",
            color: "action",
          },
        ]}
      />
    </>
  </Modal>
);

export default RefreshDataModal;
